import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { Validators } from '@angular/forms';

@Component({
  selector: 'app-chat-with-surveys-dialog-component',
  templateUrl: './chat-with-surveys-dialog-component.component.html',
  styleUrls: ['./chat-with-surveys-dialog-component.component.css']
})
export class ChatWithSurveysDialogComponentComponent implements OnInit {

  private surveyChatApiDomain = 'https://nlp.lexcore.ai';
  surveyForm: FormGroup;
  surveys = [
    { id: 1, name: 'Customer Satisfaction Survey' },
    { id: 2, name: 'Product Feedback Survey' },
    { id: 3, name: 'Employee Engagement Survey' }
  ];
  selectedSurveys = [];
  isLoading = false;
  resultsGenerated = false;
  results: any = null;
  today: Date;


  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<ChatWithSurveysDialogComponentComponent>,
    private http: HttpClient
  ) {}

  ngOnInit(): void {
    this.today = new Date();
    this.initForm();
  }

  initForm(): void {

    this.surveyForm = this.fb.group({
      analysisType: ['Q&A', Validators.required],
      startDate: [null, Validators.required],
      endDate: [null, Validators.required],
      question: ['', Validators.required]
    });

    this.surveyForm.get('analysisType').valueChanges.subscribe(value => {
      const questionControl = this.surveyForm.get('question');
      if (value === 'Q&A') {
        questionControl.setValidators(Validators.required);
      } else {
        questionControl.clearValidators();
      }
      questionControl.updateValueAndValidity();
    });
  }

  

  onSurveySelectionChange(survey): void {
    const index = this.selectedSurveys.findIndex(s => s.id === survey.id);
    if (index === -1) {
      this.selectedSurveys.push(survey);
    } else {
      this.selectedSurveys.splice(index, 1);
    }
  }

  removeSurvey(survey): void {
    this.selectedSurveys = this.selectedSurveys.filter(s => s.id !== survey.id);

  }

  close(): void {
    this.dialogRef.close();
  }

  formatDateOnly(date: Date): string {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  generateInsights(): void {
    if (!this.surveyForm.valid) {
      this.surveyForm.markAllAsTouched();
      return;
    }
    this.isLoading = true;
    this.resultsGenerated = false;

    const startDate = this.surveyForm.get('startDate').value;
    const endDate = this.surveyForm.get('endDate').value;
    const analysisType = this.surveyForm.get('analysisType').value;
    const payload = {
      channel: "RBM_Group",
      namespace: "latest_resturaunt_reviews",
      start_date: this.formatDateOnly(startDate),
      end_date: this.formatDateOnly(endDate),
    };

    let apiEndpoint = '';
    
    if (analysisType === 'Q&A') {
      apiEndpoint = `${this.surveyChatApiDomain}/lex/gpt/datasource/daterange/qa`;
      payload['query'] = this.surveyForm.get('question').value;
    } else {
      apiEndpoint = `${this.surveyChatApiDomain}/lex/gpt/datasource/daterange/summary`;
    }

    this.http.post(apiEndpoint, payload).subscribe(
      (response: any) => {
        if (analysisType === 'Q&A') {
          this.results = response.answer;
        } else {
          try {
            const summaryData = JSON.parse(response.summary);
            this.results = {
              output_text: summaryData.summary
            };
          } catch (error) {
            console.error('Error parsing summary JSON:', error);
            this.results = {
              output_text: response.summary
            };
          }
        }
        
        this.resultsGenerated = true;
        this.isLoading = false;
      },
      error => {
        console.error('Error generating insights:', error);
        this.isLoading = false;
      }
    );
  }

  redirectToDashboard(): void {
    const dashboardUrl = 'https://us-west-2.quicksight.aws.amazon.com/sn/accounts/371035212723/dashboards/a3d052b2-6cb7-4d8c-a217-17cce91ec66a?directory_alias=lexcore'; 
    window.open(dashboardUrl, '_blank');
  }

}
